import { createActions, createReducer } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getPerksRequest: ["payload"], // payload: { params }
  getPerksSuccess: ["payload"], // payload: { data }
  getPerksFailure: ["payload"], // payload: { errors }

  logout: null
})

export const PerksTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  list: [],
  error: null
})

/* ------------- Reducers ------------- */

const getPerksRequest = (state) => state.merge({ fetching: true, error: null })

const getPerksSuccess = (state, { payload }) => {
  const list = Array.isArray(payload) ? payload : payload?.results || []
  return state.merge({ fetching: false, list })
}

const getPerksFailure = (state, { payload }) => state.merge({ fetching: false, error: payload })

const logout = () => INITIAL_STATE

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_PERKS_REQUEST]: getPerksRequest,
  [Types.GET_PERKS_SUCCESS]: getPerksSuccess,
  [Types.GET_PERKS_FAILURE]: getPerksFailure,
  [Types.LOGOUT]: logout
})
